let NAME = "";

export const setCompanyName = (n) => { NAME = n || ""; };
export const companyName = () => NAME || "Your Company";
export const companyUpper = () => companyName().toUpperCase();
